var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "infomaterialien" }, [
    _c("header", { staticClass: "page-header" }, [
      _c("div", { staticClass: "heading-container" }, [
        _c("div", { staticClass: "heading-container-inner" }, [
          _c("div", {
            staticClass: "image-container d-none d-sm-block",
            style: {
              backgroundImage:
                "url(" +
                (_vm.page["acf"]["desktop_image"]
                  ? _vm.page["acf"]["desktop_image"]
                  : "/img/page-banner.png") +
                ")"
            }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "image-container d-block d-sm-none",
            style: {
              backgroundImage:
                "url(" +
                (_vm.page["acf"]["mobile_image"]
                  ? _vm.page["acf"]["desktop_image"]
                  : "/img/page-banner.png") +
                ")"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "overlay" }),
          _vm._v(" "),
          _c("h1", {
            staticClass: "heading text-uppercase",
            domProps: {
              innerHTML: _vm._s(
                _vm.page["acf"]["heading"]
                  ? _vm.page["acf"]["heading"]
                  : _vm.page.title["rendered"]
              )
            }
          })
        ]),
        _vm._v(" "),
        _vm.page["acf"]["image_copyright_text"]
          ? _c("div", {
              staticClass: "image-copyright-text",
              domProps: {
                innerHTML: _vm._s(
                  "&copy; " + _vm.page["acf"]["image_copyright_text"]
                )
              }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      (_vm.page["acf"]["sub_heading"] || _vm.page["acf"]["short_text"]) &&
      _vm.showContactForm === false
        ? _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "page-details" }, [
              _vm.page["acf"]["sub_heading"]
                ? _c("h2", {
                    staticClass: "sub-heading",
                    domProps: {
                      innerHTML: _vm._s(_vm.page["acf"]["sub_heading"])
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.page["acf"]["short_text"]
                ? _c("div", {
                    staticClass: "short-text mb-0",
                    domProps: {
                      innerHTML: _vm._s(_vm.page["acf"]["short_text"])
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "btn btn-pink-white ani-btn-hover-scale-bounce mt-4",
                  on: {
                    click: function($event) {
                      return _vm.loadContactForm("")
                    }
                  }
                },
                [
                  _vm._v("Zum\n                    Bestellformular"),
                  _c("i", { staticClass: "arrow arrow-right" })
                ]
              )
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.page["acf"]["infomaterial"] && _vm.showContactForm === false
      ? _c("div", { staticClass: "infomaterial-container" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c(
              "div",
              { staticClass: "infomaterial-inner" },
              _vm._l(_vm.page["acf"]["infomaterial"], function(infomaterial) {
                return _c("div", { staticClass: "infomaterial-item" }, [
                  _c(
                    "div",
                    { staticClass: "infomaterial-item-thumbnail-container" },
                    [
                      infomaterial.infomaterial_item.infomaterial_item_thumbnail
                        ? _c("img", {
                            staticClass: "infomaterial-item-thumbnail",
                            attrs: {
                              alt:
                                infomaterial.infomaterial_item
                                  .infomaterial_item_title,
                              src:
                                infomaterial.infomaterial_item
                                  .infomaterial_item_thumbnail
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      infomaterial.infomaterial_item
                        .infomaterial_item_thumbnail_992x285
                        ? _c("img", {
                            staticClass: "infomaterial-item-thumbnail-992-285",
                            attrs: {
                              alt:
                                infomaterial.infomaterial_item
                                  .infomaterial_item_title,
                              src:
                                infomaterial.infomaterial_item
                                  .infomaterial_item_thumbnail_992x285
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "infomaterial-item-content-container p-3 py-md-4"
                    },
                    [
                      _c("p", {
                        staticClass:
                          "infomaterial-item-title font-weight-bold text-uppercase",
                        domProps: {
                          innerHTML: _vm._s(
                            infomaterial.infomaterial_item
                              .infomaterial_item_title
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("h3", {
                        staticClass:
                          "infomaterial-item-heading font-weight-bold text-uppercase",
                        domProps: {
                          innerHTML: _vm._s(
                            infomaterial.infomaterial_item
                              .infomaterial_item_heading
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "infomaterial-item-description",
                        domProps: {
                          innerHTML: _vm._s(
                            infomaterial.infomaterial_item
                              .infomaterial_item_description
                          )
                        }
                      }),
                      _vm._v(" "),
                      infomaterial.infomaterial_item
                        .infomaterial_item_downloadable
                        .infomaterial_item_downloadable_file ||
                      infomaterial.infomaterial_item
                        .infomaterial_item_order_button_text
                        ? _c("div", { staticClass: "btn-container" }, [
                            infomaterial.infomaterial_item
                              .infomaterial_item_downloadable
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-black-white",
                                    attrs: {
                                      target: "_blank",
                                      href:
                                        infomaterial.infomaterial_item
                                          .infomaterial_item_downloadable
                                          .infomaterial_item_downloadable_file
                                    }
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          infomaterial.infomaterial_item
                                            .infomaterial_item_downloadable
                                            .infomaterial_item_downloadable_button_text
                                            ? infomaterial.infomaterial_item
                                                .infomaterial_item_downloadable
                                                .infomaterial_item_downloadable_button_text
                                            : "PDF herunterladen"
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("i", { staticClass: "arrow arrow-down" })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            infomaterial.infomaterial_item
                              .infomaterial_item_order_button
                              .infomaterial_item_order_button_link
                              ? _c("a", {
                                  staticClass: "btn btn-pink-white",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      (infomaterial.infomaterial_item
                                        .infomaterial_item_order_button
                                        .infomaterial_item_order_button_link
                                        ? infomaterial.infomaterial_item
                                            .infomaterial_item_order_button
                                            .infomaterial_item_order_button_text
                                        : "Bestellen") +
                                        "<i class='arrow arrow-right'></i>"
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.loadContactForm(
                                        infomaterial.infomaterial_item
                                          .infomaterial_item_order_button
                                          .infomaterial_item_order_button_link
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              }),
              0
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.showContactForm !== false &&
              _vm.page.content &&
              _vm.page.content.rendered,
            expression:
              "showContactForm !== false && page.content && page.content.rendered"
          }
        ],
        staticClass: "bestellformular-content"
      },
      [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", {
            ref: "contactForm",
            staticClass: "bestellformular-content-inner",
            domProps: {
              innerHTML: _vm._s(_vm.page.content && _vm.page.content.rendered)
            }
          })
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-721ce09c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-721ce09c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/Infomaterialien.vue
// module id = 650
// module chunks = 0